import React, { Component } from 'react';
import classes from './PaymentType.css';
import Input from '../../../components/UI/Input/Input';
import { connect } from 'react-redux';
import { checkValidity } from '../../../shared/utility';

class PaymentType extends Component {
    state = {
        orderForm: {
            cashAmount: {    
                label: 'Cash',
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: '0'
                },            
                validation: {
                    required: false,
                    isNumeric: true
               }
            },
            checkAmount: { 
                label: 'Check',
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: '0'
                },    
                        
                validation: {
                    required: false,
                    isNumeric: true
                }
            },
            checkNumber: {                  
                label: 'Check #',
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: ''
                }  
            }
        }
    }
   

    inputChangedHandler = (event, inputIdentifier) => {
        let val = event.target.value;
        if (val === undefined || val === '') {
            val = '0';
        }

        let valid = checkValidity(val, this.state.orderForm[inputIdentifier].validation);
        this.props.onDataChanged(inputIdentifier + '_touched', true);
        this.props.onDataChanged(inputIdentifier, val);
        this.props.onDataChanged(inputIdentifier + '_valid', valid);

        if (valid) {
            this.props.onDataChanged(inputIdentifier + '_valid', true);
            if (inputIdentifier == "cashAmount") {
                if (parseFloat(val) > 0 || this.props.checkAmount > 0)
                { 
                    this.props.onDataChanged('paymentStatus',"paid");
                    this.props.onDataChanged('paymentStatus_touched',true);
                }            
                else {
                    this.props.onDataChanged('paymentStatus',"unpaid");
                    this.props.onDataChanged('paymentStatus_touched',true);
                }
            } 
            else if (inputIdentifier == "checkAmount") {
                if (parseFloat(val) > 0 || this.props.cashAmount > 0)
                { 
                    this.props.onDataChanged('paymentStatus',"paid");
                    this.props.onDataChanged('paymentStatus_touched',true);
                }            
                else {
                    this.props.onDataChanged('paymentStatus',"unpaid");
                    this.props.onDataChanged('paymentStatus_touched',true);
                }
            }       
        }

    }

    formatNumber(value) {
        if (!value || value == '') {
          return '0.00';
        }
        else {
          return parseFloat(value).toFixed(2);
        }
      }

      

    render () {

        const formElementsArray = [];
        for (let key in this.state.orderForm) {
            let label = this.state.orderForm[key].label;
            formElementsArray.push({
                id: key,
                config: this.state.orderForm[key],
                label: label
            });
        }

        let form = (
            <form onSubmit={this.orderHandler}>
                {formElementsArray.map(formElement => (
                    
                    <Input
                        key={formElement.id}
                        label={formElement.config.label}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={this.props[formElement.id]}
                        invalid={!this.props[formElement.id + '_valid']}
                        shouldValidate={formElement.config.validation}
                        touched={this.props[formElement.id + '_touched']}
                        changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                ))}
            </form>
        );

        

        return (
            <div className={classes.PaymentType}>
                <h4>Payment Types</h4>
                {form}
            </div>
        );
    }
};


const mapStateToProps = state => {
    return {
        paymentStatus: state.orders.order.paymentStatus,
        cashAmount: state.orders.order.cashAmount,
        cashAmount_valid: state.orders.order.cashAmount_valid,
        cashAmount_touched: state.orders.order.cashAmount_touched,
        checkAmount: state.orders.order.checkAmount,
        checkAmount_valid: state.orders.order.checkAmount_valid,
        checkAmount_touched: state.orders.order.checkAmount_touched,
        checkNumber: state.orders.order.checkNumber,
        checkNumber_valid: state.orders.order.checkNumber_valid,
        checkNumber_touched: state.orders.order.checkNumber_touched,
        isAuthenticated: state.orders.token !== null
    };
}


export default connect(mapStateToProps)( PaymentType);


// WEBPACK FOOTER //
// ./src/components/Order/PaymentType/PaymentType.js